module.exports = __webpack_public_path__ + "img/telesticker-banner.3a6ff66e.jpg";